<template>
    <modal
        :id="id"
        dialog-class="modal-dialog-vertical"
        :actionButtons="!hideForm"
        :closeButton="hideForm"
        modal-class="fade fixed-right"
        @shown="shown"
    >
        <template slot="modal-header">
            <div class="card-header fixed py-0" style="width:100%" @click="hidePopover">
                <div class="row align-items-center">
                    <div class="col d-flex align-items-center justify-content-between">
                        <tabs :tabs="waitingListTabs" :value="currentTab" @input="waitingListTabChanged"></tabs>
                    </div>
                    <div class="col-auto">
                        <button type="button" class="close" aria-label="Close" @click="close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                </div>
            </div>
        </template>
        <div class="row in-waiting-list-modal d-block" @click="hidePopover">
            <slot></slot>
        </div>
        <template slot="modal-footer">
            <div class="card-footer" style="display:block" @click="hidePopover">
                <div class="row">
                    <div class="col">
                        <button
                            class="btn btn-outline-info"
                            v-if="$loadModule('appointment') && currentTab == 'waitingList'"
                            @click.prevent="newAppointment"
                            v-b-tooltip.hover
                            :title="$t('Add to waiting list')"
                        >
                            <span class="fe fe-plus"></span>
                        </button>
                    </div>
                    <div class="col-auto">
                        <button type="button" @click="close" class="btn btn-white">{{ $t('Close') }}</button>
                    </div>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import { modalMixins } from '@/mixins/modal.js';
import Tabs from '@/components/Tabs';

export default {
    props: ['id', 'currentTab'],
    components: {
        Modal,
        Tabs,
    },
    mixins: [modalMixins],
    data() {
        return {
            hideForm: false,
            appointmentDefaults: {
                appointmentAt: this.$moment().add(1, "day"),
                services: [{}],
                inWaitingList: true,
            },
        }
    },
    methods: {
        close() {
            this.$root.$emit('bv::hide::modal', this.id)
        },
        hidePopover() {
            this.$root.$emit('bv::hide::popover');
        },
        newAppointment() {
            let appointment = {
                model: this.appointmentDefaults,
                _id: 'temp'
            };
            const { Appointment } = this.$FeathersVuex
            new Appointment(appointment);
            this.openModal({ id: 'AppointmentFastModal' });
        },
        shown() {
            this.$root.$emit('bv::hide::tooltip');
        },
        waitingListTabChanged(tab) {
            this.$emit('waitingListTabChanged', tab);
        },
    },
    computed: {
        waitingListTabs() {
            const tabs = [
                {
                    text: this.$t('Waiting List'),
                    value: 'waitingList'
                }
            ];
            if (this.$loadModule('onlineRegistration')){
                tabs.push({
                    text: this.$t('Online appointments'),
                    value: 'drafts'
                });
            }
            return tabs;
        }
    }
}
</script>

<style lang="scss" scoped>
    .row.in-waiting-list-modal.d-block:after {
        content: '';
        position: absolute;
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
    }
</style>
